<template>
  <my-echarts :option="option" :style="{ width: props.width, height: props.height }"></my-echarts>
</template>

<script setup>
import { ref, watch, defineExpose } from "vue";
const props = defineProps({
  dataSource: {
    type: Array,
    default: () => [],
  },
  width: {
    type: String,
    default: "440px",
  },
  height: {
    type: String,
    default: "380px",
  },
  colorList: {
    type: Array,
    default: () => ['#3671FE', '#18D991', '#36CDF3', '#F6BD16', '#FF8A55', '#F64E16'],
  }
});
const option = ref({});
const initData = () => {
  option.value = {
    color: props.colorList,
    dataset: {
      dimensions: ['count', 'name'],
      source: props.dataSource,
    },
    series: [
      {
        name: 'funnel',
        type: 'funnel',
        sort: 'none',
        left: 0,
        top: 0,
        bottom: 0,
        width: '100%',
        minSize: '0%',
        sort: 'descending',////漏斗数据降序排列
        gap: 2,//数据图形间距
        label: {//漏斗图图形上的文本标签
          show: true,//显示文本标签
          position: 'inside'//标签的位置：漏斗图梯形内部
        },
        labelLine: {//标签的视觉引导线样式
          length: 10,//视觉引导线的长度
          lineStyle: {//线的样式
            width: 1,//宽度
            type: 'solid'
          }
        },
        itemStyle: {//图形样式
          borderColor: '#fff',//图形的描边颜色
          borderWidth: 1//图形描边宽度
        },
        label: {
          show: true,
          position: 'inside',
          // formatter(params){
          //   return  params.data.product + params.data.count 
          // },
          color: '#fff'
        },
      }
    ],
  };
};
watch(() => props.dataSource, () => {
  initData()
},
  { immediate: true, deep: true }
);
defineExpose({
  option,
});
</script>